
import AlertModule from 'vux/src/plugins/alert/module'


export default {

/**
* 金额-阿拉伯数字转汉字
* */
changeMoneyToChinese(money){
let cnNums = new Array("零","壹","贰","叁","肆","伍","陆","柒","捌","玖"); 
let cnIntRadice = new Array("","拾","佰","仟"); 
let cnIntUnits = new Array("","万","亿","兆"); 
let cnDecUnits = new Array("角","分","毫","厘"); 
let cnIntLast = "元"; 
let maxNum = 999999999999999.9999; 

let IntegerNum; 
let DecimalNum; 
let ChineseStr=""; 
let parts; 
if( money == "" ){
return "";
}
money = parseFloat(money);
if( money >= maxNum ){
$.alert('超出最大处理数字');
return "";
}
if( money == 0 ){
ChineseStr = cnNums[0]+cnIntLast
return ChineseStr;
}
money = money.toString(); 
if( money.indexOf(".") == -1 ){
IntegerNum = money;
DecimalNum = '';
}else{
parts = money.split(".");
IntegerNum = parts[0];
DecimalNum = parts[1].substr(0,4);
}
if( parseInt(IntegerNum,10) > 0 ){//获取整型部分转换
let zeroCount = 0;
let IntLen = IntegerNum.length;
for(let i=0;i<IntLen;i++){
let n = IntegerNum.substr(i,1);
let p = IntLen - i - 1;
let q = p / 4;
let m = p % 4;
if( n == "0" ){
zeroCount++;
}else{
if( zeroCount > 0 ){
ChineseStr += cnNums[0];
}
zeroCount = 0; 
ChineseStr += cnNums[parseInt(n)]+cnIntRadice[m];
}
if( m==0 && zeroCount<4 ){
ChineseStr += cnIntUnits[q];
}
}
ChineseStr += cnIntLast;

}
if( DecimalNum!= '' ){//小数部分
let decLen = DecimalNum.length;
for(let i=0; i<decLen;i++){
let n = DecimalNum.substr(i,1);
if( n != '0' ){
ChineseStr += cnNums[Number(n)]+cnDecUnits[i];
}
}
}
if( ChineseStr == '' ){
ChineseStr += cnNums[0]+cnIntLast;
}
return ChineseStr;
},

/**
* 功能开发中-提示
* */
notFound(){
AlertModule.show({
title: '开发中...'
})
},

/**
* toast提示框，2s后消失
* */
showToastMsg (msg) {
this.$vux.toast.show({
text: msg,
type: 'text',
position: 'middle',
width: '50%'
})
},

}




// WEBPACK FOOTER //
// ./src/assets/js/common.js